import React, { useEffect, useState } from 'react';
import {
  Link,
  LoadingWrapper,
  LogoWrapper,
  PoweredByWrapper,
  Wrapper,
} from './SharedReportPublic';
import {
  Logo,
  Typography,
  Input,
  Button,
  showToast,
} from '@deeptrue-frontend/ui';
import { CircularProgress } from '@material-ui/core';
import { useFormatMessage } from 'components/IntlProvider';
import { Formik, Field } from 'formik';
import styled from 'styled-components/macro';
import ModalWithTitle from 'components/Modal/ModalWIthTitle';
import api from 'api';
import SharedReport from './SharedReport';
import queryString from 'query-string';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { compose } from 'ramda';
const { connect, selectors, actions } = StoreProvider;

const Content = styled.div`
  width: 100%;
`;

const StyledButton = styled(Button)`
  width:100%:
`;

const SharedReportPrivate = ({ match, location, setLanguage }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [report, setReport] = useState();
  const { linkId, organizationId } = match.params;
  const t = useFormatMessage();
  const { language } = queryString.parse(location.search);
  useEffect(() => {
    if (language) {
      setLanguage(language);
    }

    // eslint-disable-next-line
  }, [language]);

  const submitValues = (val: any) => {
    return api.resources
      .getSharedReport({
        organizationCodename: organizationId,
        linkId: linkId,
        password: val.password,
      })
      .then((resp: any) => {
        setReport(resp.data);
        setIsOpen(false);
      })
      .catch(() => {
        setIsLoading(false);
        showToast({
          type: 'error',
          title: t(
            'errors.toast.general',
            'Something went wrong, please contact administrator'
          ),
        });
      });
  };

  return (
    <Wrapper>
      {isLoading ? (
        <LoadingWrapper>
          <CircularProgress size={48} color="primary" />
        </LoadingWrapper>
      ) : (
        report && (
          <SharedReport
            report={report}
            organization={organizationId}
            linkId={linkId}
          />
        )
      )}
      <ModalWithTitle
        title={t(
          'project.share.shareReportLinks.accessPrivate',
          'Password restricted'
        )}
        open={isOpen}
        onClose={() => null}
      >
        <Formik onSubmit={submitValues} initialValues={{ password: '' }}>
          {({ handleSubmit, isSubmitting }) => {
            return (
              <Content>
                <Field
                  as={Input}
                  name="password"
                  placeholder={t(
                    'project.share.shareReportLinks.typePassword',
                    'Type password'
                  )}
                />
                <StyledButton
                  // @ts-ignore
                  onClick={handleSubmit}
                  type="submit"
                  isLoading={isSubmitting}
                >
                  {t('pages.project.modal.confirm', 'Confirm')}
                </StyledButton>
              </Content>
            );
          }}
        </Formik>
      </ModalWithTitle>

      <PoweredByWrapper>
        <LogoWrapper>
          <Typography>Powered by</Typography>
          <Link
            href="https://www.deeptrue.com/"
            target="_blank"
            rel="noreferrer"
          >
            <Logo />
          </Link>
        </LogoWrapper>
      </PoweredByWrapper>
    </Wrapper>
  );
};

export default compose(
  connect(
    (state) => ({
      language: selectors.intlSelectors.language(state),
    }),
    {
      setLanguage: actions.intlActions.setLanguage,
    }
  )
)(SharedReportPrivate);
